import { EnrichedAssignmentMetricsByWorkload } from '@/pages/OperationsInsights/types/AssignmentMetricsResponseEnriched';
import DurationInMinutesCellRenderer from '@/pages/agGridUtils/DurationInMinutesCellRenderer.vue';

/**
 * Transform Grid Data for - Average Assignment Completion Time by Workload
 *
 * @param metrics
 */
export const tfGdAssignmentAvgCompletedTimeByWorkload = (metrics: EnrichedAssignmentMetricsByWorkload[]) => {
    const gridMap = new Map<number, object>();
    for (const assignmentMetric of metrics) {

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const row: any = {
            name: assignmentMetric.name,
            averageCompletionTimeInMinutes: assignmentMetric.averageCompletionTimeInMinutes
        };
        gridMap.set(assignmentMetric.workloadId, row);
    }
    return Array.from(gridMap.values());
};

/**
 * Colum Definition for Average Assignment Completion Time by Workload
 */
export const getAssignmentAvgCompletedTimeByWorkloadColumnDefs = () => {
    return [
        {
            field: 'name', headerName: 'Workload', minWidth: 220, filter: true
        },
        {
            field: 'averageCompletionTimeInMinutes',
            headerName: 'Avg Time to Completion',
            cellRenderer: DurationInMinutesCellRenderer,
            minWidth: 170,
            filter: true
        }
    ];
};